module.exports = {
  // 通用部分
  common: {
    dataType: "Data type",
    tip: "Tip",
    orgName: "Organization Name",
    searchTip: "Enter keyword to search",
    contextTip: "Enter content",
    filterTip: "Enter keyword to filter",
    choseTip: "Please choose",
    other: "Other",
    remarks: "Remarks",
    all: "All",
    onLine: "Online",
    offLine: "Offline",
    equal: "Equal to",
    unequal: "Not equal to",
    date: "Date",
    dateRange: "Date Range",
    to: "To",
    reach: "Reach",
    starDate: "Start Date",
    endDate: "End Date",
    nearlyMonth: "Last Month",
    cumulativeTime: "Cumulative Time",
    timeOfTheMonth: "This Month",
    timeOfTheDay: "Today",
    choseTime: "Select Time",
    noData: "No data",
    twentyFourHourSystem: "24-Hour System",
    eightHourSystem: "8-Hour System",
    dayUseRate: "Daily Usage Rate",
    manufactureNum: "Manufacture Number",
    carId: "Vehicle ID",
    plateNum: "License Plate",
    customNum: "Custom Number",
    orgName: "Organization Name",
    terminalId: "Terminal ID",
    driverNum: "Driver's License Number",
    messageTime: "Report Time",
    linkState: "Device Status",
    createTime: "Creation Date",
    lastUser: "Last User",
    brand: "Brand",
    model: "Model",
    updateTime: "Update Time",
    setUpTime: "Setup Time",
    driverName: "Driver's Name",
    remark: "Remark",
    num: "Number",
    id: "ID",
    companyName: "Company Name",
    picture: "Picture",
    video: "video",
    normal: "Normal",
    abnormal: "Abnormal",
    nearTime: "Near Expiry",
    exceedTime: "Expired",
    reportedSuspended: "Reported as suspended",
    province: "Province",
    city: "City",
    address: "Address",
    number: "number",
    registrationCode: "Registration code",
    externalNumber: "External Number",
    scrap: "Scrap",
    leaseTerm: "Lease term",
    forklift: "forklift",
    rgv: "RGV",
    form: {
      orgName: "Select Organization",
      orgTip: "Please select department",
      rolePower: "Please select role",
      roleData: "Data Permission",
      choseTip: "Please choose",
      state: "Please select device status",
      terminalId: "Enter terminal ID",
      terminalType: "Select terminal type",
      groupId: "Select terminal upload type",
      keyId: "Select command name",
      dirver: "Select driver",
      group: "Select team",
      email: "Enter email",
      sort: "Enter the correct sorting",
    },
    btn: {
      search: "Search",
      replace: "Replace",
      confirmReplace: "Are you sure to replace?",
      replaceSuccess: "Replace Successful",
      add: "Add",
      addSuccess: "Add Successful",
      edit: "Edit",
      editSuccess: "Edit Successful",
      delete: "Delete",
      confirmDelete: "Are you sure to delete?",
      deleteSuccess: "Delete Successful",
      confirmReset: "Are you sure to reset?",
      resetPass: "Reset Password",
      resetPassSuccess: "Reset Successful",
      refresh: "Refresh",
      refreshSuccess: "Refresh Successful",
      hint: "Hint",
      confirm: "Confirm",
      cancel: "Cancel",
      confirmCancel: "Are you sure to cancel?",
      cancelSuccess: "Cancel Successful",
      batchUpload: "Batch Upload",
      batchDelete: "Batch Delete",
      upload: "Upload",
      download: "Download",
      detail: "Detail",
      operate: "Operate",
      downloadFile: "Download Attachment",
      downloadModelFile: "Download Template File",
      uploadFile: "Upload Attachment",
      clickUploadFile: "Click to upload file",
      choseExcelFile: "Please choose Excel format file for import!",
      bind: "Bind",
      bindSuccess: "Bind Successful",
      unBind: "Unbind",
      unBindSuccess: "Unbind Successful",
      transferSuccess: "Transfer Successful",
      transfer: "Transfer",
      clear: "Clear",
      sync: "Sync",
      confirmClear: "Are you sure to clear?",
      clearSuccess: "Clear Successful",
      confirmSubmit: "Are you sure to submit?",
      submitSuccess: "Submit Successful",
      refreshSuccess: "Refresh Successful",
      authSuccess: "Authorization Successful",
      submit: "Submit",
      goback: "Go Back",
      listsetting: "Column Configuration",
      choseDate: "Select Date",
      uploadPicture: "Please upload picture",
      fileUploadSuccess: "File uploaded successfully",
      fileUploadError: "Failed to upload file",
      bindText: "This action will unbind, continue?",
      rolePower: "Role Permissions",
      roleData: "Data Permissions",
      operateDetail: "Operation Details",
      click: "Click",
      clickUpload: "Click to upload",
      onlyUploadxlsOrxlsx: "Only upload xls/xlsx files",
      onlyUploadpdfOrimg: "Only PDF/JPG/PNG files can be uploaded",
      maintenanceDetails: "Maintenance Details",
      driverPush: "Driver push",
    },
    search: {
      whole: "All",
      dateSearch: "Select date",
      outWarranty: "Out of warranty",
      inWarranty: "In warranty",
    },
    size: "Size",
    pleaseSelectCar: "Please select a vehicle",
    queryFailed: "Query failed",
    downloadSuccess: "Download successful",
    downloadFailed: "Download failed",
    loading: "Loading...",
  },
  //登录
  Login: {
    // title: "Forklift Intelligent Management System",
    title: "Smart Fleet Management System",
    login: "Login",
    forgetPass: "Forget Password?",
    loginName: "Username",
    loginNameMessage: "Please enter username",
    loginPwd: "Password",
    loginPwdMessage: "Please enter password",
  },
  //置顶栏
  TopBar: {
    home: "Home",
    pass: "Change Password",
    exit: "Exit System",
    oldPass: "Old Password",
    newPass: "New Password",
    message: "Message",
    carCurrentFault: "Current Vehicle Faults",
    driverCurrentViolation: "Current Driver Violations",
    carIdOrManufactureNum: "Vehicle ID/Manufacture Number",
    faultType: "Fault Type",
    faultTime: "Fault Time",
    driverNumOrDriverName: "Driver's License Number/Driver's Name",
    violationType: "Violation Type",
    violationTime: "Violation Time",
    contactName: "Contact Person",
    happenTime: "Happen Time",
    phone: "Contact Number",
    describe: "Description",
    en: "English",
    eventMessage: "Fault Type",
    startTime: "Start Time",
    handleState: "Handle State",
    noHandle: "Not Handled",
    handle: "Handled",
    ignored: "Ignored",
    push: "Push",
    repair: "Repair",

    form: {
      confirmPass: "Confirm Password",
      imputPass: "Please input password",
      imputPassAgain: "Please input password again",
      passDifferent: "Passwords entered do not match!",
      carId: "Please enter vehicle ID",
      contactName: "Please enter contact person",
      happenTime: "Please select happen time",
      phone: "Please enter phone number",
      yourBrowserDoesNotSupportFullScreen: "Your browser does not support full screen",
      confirmIgnore: "Are you sure to ignore?",
      ignoreSuccess: "Ignored successfully",
      confirmPush: "Are you sure to push?",
      pushSuccess: "Pushed successfully",
    },
    btn: {
      selfSet: "Customize Settings",
      ignore: "Ignore",
    }
  },
  // 菜单
  NavMenu: {
    home: "Home",
    VehicleManagement: "Vehicle Management",
    VehicleFiles: "Vehicle Files",
    VideoPreview: "Video Preview",
    VehicleAnnualReview: "Vehicle Annual Review",
    VehicleStatus: "Vehicle Status",
    VehicleDistribution: "Vehicle Distribution",
    VehicleTrajectory: "Vehicle Trajectory",
    ElectricFence: "Electric Fence",
    CloudFence: "Cloud Fence",
    EquipmentControl: "Equipment Control",
    CarRepair: "vehicle maintenance",
    RepairManagement: "Repair management",
    MaintainManagement: "Maintenance Management",
    MaintenanceProgram: "maintenance program",
    MaintenanceManagement: "Maintenance Management",
    Details: "Detail Page",
    InsureFile: "Insurance Files",

    DriverManagement: "Driver Management",
    DriverFile: "Driver Files",
    DriverAnnualReview: "Driver Annual Review",
    DriverStatus: "Driver Status",
    KeyFile: "IC Card Files",
    DriverFingerprintFile: "Driver Fingerprint Files",
    NewDriverFingerprintFile: "Driver Fingerprint Files (New)",
    FingerprintLibraryFile: "Fingerprint Library Files",
    AuthorizationManagement: "Driver On-site Authorization",
    DriverAuthorizationManagement: "Driver Remote Authorization",
    FingerprintAuthorization: "Fingerprint Library Remote Authorization",
    DriverFaceFile: "Driver Face Files",
    ICEmpower: "IC Card Authorization Management",
    FaceAuthorize: "Face Authorization",
    DriverTrain: "Driver Training",
    DriverTeam: "Driver team",

    BatteryManagement: "Battery Management",
    BatteryFile: "Battery Files",
    BatteryStatus: "Battery Status",

    SafeManagement: "Safety Management",
    FaultManagement: "Fault Management",
    ViolationControl: "Violation Control",

    DataAnalysis: "Efficiency Analysis",
    VehicleAnalysis: "Vehicle Analysis",
    Comprehensive: "Comprehensive Vehicle Efficiency",
    Efficiency: "Vehicle Efficiency Analysis",
    Duration: "Vehicle Duration Analysis",
    Fault: "Vehicle Fault Analysis",
    DriverAnalysis: "Driver Analysis",
    DriverComprehensive: "Comprehensive Driver Efficiency",
    DriverEfficiency: "Driver Efficiency Analysis",
    DriverDuration: "Driver Duration Analysis",
    DriverViolation: "Driver Violation Analysis",
    BatteryAnalysis: "Battery Analysis",
    MaintenanceAnalysis: "Maintenance Analysis",
    CarCheck: "Vehicle Inspection",
    VehicleOrgReport: "Vehicle Team Reports",
    DriverOrgReport: "Driver Team Reports",
    MaintenanceItemAnalysis: "Maintenance item analysis",
    VehicleOperationRecords: "Vehicle Operation Records",

    PlatformSettings: "System Settings",
    userManagement: "User Management",
    roleManagement: "Role Management",
    MenuManagement: "menu management",
    organizaManagement: "Organization Management",
    dictionaryManagement: "Brand and Model Management",
    checkManagement: "Inspection Item Management",
    ReportPush: "Report Push",

    BackgroundSettings: "Background Settings",
    TerminalCommand: "Terminal Commands",
    CompanyManagement: "Company Management",
    JurisdictionalManagement: "Jurisdictional Management",
    OTAManagement: "OTA Management",
    DictionaryManaged: "Dictionary Management",
    DictionaryItem: "Dictionary Items",
    TerminalFile: "Terminal Files",
    SIMFile: "SIM card profile",
    ExternalEqu: "External Equipment",
    EquipmentRenewal: "Equipment renewal",

    AccounManagement: "Business Management",
    ContractManagement: "Contract Management",

    GovernmentRegulation: "Government Regulation",
    JurisdictionalCompanies: "Jurisdictional Companies",
    JurisdictionalCar: "Jurisdictional Vehicle Search",
    JurisdictionalDriver: "Jurisdictional Driver Search",
    JurisdictionalAnalysis: "Jurisdictional Analysis",
    Comprehensive: "Comprehensive Analysis",
    Secure: "Safety Analysis",
    EnforcementNotes: "Enforcement Notes",
    NoteDetail: "Note Details",
    PolicyRule: "Policy Rules",
    AnnualReview: "Annual Review Approval",

  },
  VideoPreview: {
    liveVideo: "live video",
    historyVideo: "history video",
    dmsCamera: "DMS Camera",
    frontCamera: "Front Camera",
    backCamera: "Back Camera",
    leftCamera: "Left Camera",
    rightCamera: "Right Camera",
    playHistoryVideo: "Play History Video",
    playFailed: "Playback Failed",
    getVideoUrlFailed: "Failed to Get Video URL",
    noVideoStream: "No Video Stream Available",
  },
  // 合同管理
  ContractManagement: {
    contractId: "Contract ID",
    typeName: "Contract Type",
    supplierName: "Supplier",
    contactName: "Contact Name",
    phone: "Contact Phone",
    signTime: "Signing Date",
    warrantyTime: "Warranty Date",
    isWarranty: "Warranty Status",
    contractMoney: "Contract Amount",
    form: {
      contractIdTip: "Enter contract ID",
      signTimeTip: "Select signing time",
      warrantyTimeTip: "Select warranty time",
      typeNameTip: "Select contract type",
      sale: "Sales Contract",
      buy: "Purchase Contract",
    },
    search: {
      warrantyTime: "Select warranty status",
    }
  },
  // 后台设置-公司管理
  CompanyManagement: {
    companyNum: "Unified Social Credit Code",
    name: "Company Name",
    companyAddress: "Company Address",
    logoPath: "Company Logo",
    companyRole: "Company Role",
    homepageUrlNumber: "Homepage URL",
    companyInform: "Company Information",
    loginInform: "Administrator Information",
    safeInform: "Security Officer Information",
    loginName: "Company Administrator Account",
    safeLoginName: "Company Security Officer Account",
    safeUserName: "Security Officer Name",
    createTime: "Creation Date",
    updateTime: "Update Date",
    lastUser: "Operator",
    bindOrg: "Organization Binding",
    editAdmin: "Edit Administrator",

    companyDetails: "Company Details",
    manageAccount: "Manager Account",
    mail: "Manager Email",
    CompanyLogo: "Company Logo",
    manager: "Manager Name",
    setPosition: "Set Position",
    companyRole: "Company Role",
    personInCharge: "person in charge",
    contactNumberOfThepersonInCharge: "Contact number of the person in charge",
    adminPhoneNumber: "Administrator's mobile phone number",
    securityPhoneNumber: "Security officer's mobile phone number",

    form: {
      name: "Enter company name",
      email: "Administrator Email",
      safeEmail: "Security Officer Email",
      resetPass: "Reset Password",
      homepageUrlNumber: "Select homepage URL",
      loginName: "Enter management account",
      userName: "Enter management name",
      safeLoginName: "Enter security officer account",
      safeUserName: "Enter security officer name",
      orgTree: "Search Organization Tree",
      menu: "Platform Page Permissions",
      appMenu: "APP Page Permissions",
      companyLogoTip: "（logo width 146px，height 51px）",
      selectCenterAndLevel: "select center and level"
    },
    btn: {
      changeRole: "Change Company Permissions",
      changeCompany: "Change Company",
      resetPassword: "Reset Password",
      selectPostion: "Select Postion",
      companyRole: "Edit Company Role",
      getCurrentLevel: "get current level"
    }
  },
  // 后台设置-字典管理
  DictionaryManaged: {
    dictId: "Dictionary Code",
    dictValue: "Dictionary Value",
    dictAdditionalValue: "Additional Information",
    dictSort: "Dictionary Sort",
    remarks: "Remarks",
    createTime: "Creation Time",
    id: "Dictionary ID",
    dictName: "Dictionary Name",
    dictType: "Dictionary Type",
    form: {
      dictValue: "Enter dictionary value",
      keyword: "Enter keyword to search",
      dictName: "Enter dictionary name",
      dictType: "Enter dictionary type",
    },
  },
  // 后台设置-外部设备
  ExternalEqu: {
    all: "All",
    externalId: "External Device ID",
    carId: "Vehicle ID",
    terminalId: "Terminal ID",
    externalTypeStr: "Device Type",
    externalType: "Device Type",
    remarks: "Remarks",
    id: "ID",
    equIMEINumber: "Equipment IMEI number",
    form: {
      terminalId: "Enter external device ID",
      typeId: "Select device type",
    },
  },
  // 后台设置-辖区管理
  JurisdictionalManagement: {
    resetPassSuccess: "Reset Password Successful",
    add: "Add Jurisdiction",
    edit: "Edit Details",
    jurisdictionNum: "Jurisdiction Number",
    jurisdictionName: "Jurisdiction Name",
    loginName: "Management Account",
    userName: "Management Name",
    logoPath: "Jurisdiction Logo",
    email: "Management Email",
    editAdmin: "Edit Administrator",
    updateUser: "Operator",
    updateTime: "Update Time",
    menu: "Platform Page Permissions",
    appMenu: "APP Page Permissions",
    choseJurisdiction: "Select Jurisdiction",
    jurisdictionInform: "Jurisdiction Information",
    email: "Management Email",
    editRole: "Edit Administrator Permissions",
    resetTip: "This action will reset the user's password, continue?",
    resetPassword: "The password after reset:",
    form: {
      jurisdictionName: "Enter jurisdiction name",
      jurisdictionNum: "Enter jurisdiction number",
      loginName: "Enter management account",
      userName: "Enter management name",
    },
  },
  // 后台设置-OTA管理
  OTAManagement: {
    issue: "Issue",
    unIssue: "Unissued",
    unpublish: "Unpublish",
    state: "State",
    typeIdStr: "Terminal Type",
    firmwareVersion: "Version Number",
    createTime: "Creation Time",
    updateTime: "Release Time",
    lastUser: "Operator",
    describe: "Description",
    isConfirmIssue: "Are you sure you want to issue",
    isConfirmCancelIssue: "Are you sure you want to cancel the issue",
    issueSuccess: "Issue Successful",
    cancelIssueSuccess: "Issue Cancel Successful",
    groupId: "Terminal Upload Type",
    uploadFile: "Upload Terminal File",
    addTermianlSetting: "Add Terminal Configuration",
    defaultVersion: "Default version",
    form: {
      no: "Enter version number",
      uploadFile: "Upload firmware package",
      groupId: "Select terminal upload type",
      typeId: "Select terminal type",
      terminalId: "Select terminal",
      uploadTerminal: "Import terminal",
      uploadTerminalFile: "Upload terminal file",
      describe: "Description",
    },
    btn: {
      addOTA: "New OTA Version",
      downloadFile: "Template Download",
      clickToUploadFile: "Click to Upload",
      changeRole: "Click to Upload",
      onlySpecialFile: "Only xls/xlsx files can be uploaded",
    }
  },
  // 后台设置-终端命令
  TerminalCommand: {
    terminalType: "Terminal Model",
    productNumber: "Product Model",
    name: "Instruction Content",
    aliKey: "Instruction Identifier",
    keyType: "Instruction Type",
    sort: 'Sort',
    explain: "Instruction Explanation",
    terminalModel: "Terminal Model:",
    newModel: "New Model",
    InsContent: "Instruction Content:",
    InsIdentifier: "Instruction Identifier:",
    InsType: "Instruction Type",
    Instructions: "Instruction Explanation",
    begin: "Enable",
    state: "Operation",
    stop: "Disable",
    beginSuccess: "Enable Successful",
    stopSuccess: "Disable Successful",
    choseTip: "Please Select",
    attSetting: "Attribute Setting",
    servSetting: "Service Setting",
    unit: "Unit",
    isShow: "Hide Display",
    hidden: "Hide",
    show: "Show",
    form: {
      terminalType: "Enter terminal model",
      productKey: "Enter product model",
      name: "Enter instruction content",
      aliKey: "Enter instruction identifier",
      keyType: "Select instruction type",
      sort: "Select sort",
      unit: "Enter unit",
      isShow: "Select hide display",
    },
    btn: {
    }
  },
  // 后台设置-终端档案
  TerminalFile: {
    terminalId: "Terminal ID",
    typeId: "Terminal Type",
    terminalModel: "Terminal Model",
    firmwareVersion: "Firmware Version",
    deliveryTime: "Manufacturing Date",
    simIccicd: "ICCID Number",
    expirationDate: 'Warranty Date',
    expirationState: "Warranty Status",
    unPush: "Not Pushed",
    push: "Pushed",
    pastDue: "past due",
    isVehicleBound: "Is the vehicle bound",
    unbound: "unbound",
    bound: "Bound",
    form: {
      terminalId: "Enter terminal ID",
      typeId: "Select terminal type",
      deliveryTime: "Select manufacturing date",
      choseExcel: "Please select an Excel format file to import!",
      pushState: "Whether to push",
      choseCarType: "Select car type",
    },
    btn: {
    }
  },
  EquipmentRenewal: {
    type: "type",
    feeType: "Fee type",
    chargingStatus: "Charging status",
    feeRemarks: "Fee Remarks",
    usageStatus: "Usage status",
    feeStandards: "Fee Standards",
    chargeStartDate: "Charge start date",
    lastPaymentDate: "Last payment date",
    expirationDate: "Expiration Date",
    chargingStatus: "Charging status",
    changeOfChargingType: "Change of charging type",
    batchRenewal: "Batch renewal",
    batchScrapping: "batchScrapping",
    charge: "charge",
    noCharge: "No charge",
    changeSuccessful: "Change successful",
    uploadFiles: "Upload files",
    RenewalTemplateDownload: "Renewal Template Download",
    scrapTemplateDownload: "Scrap template download"
  },
  SIMFile: {
    assetStatus: "Asset status",
    inUse: "In use",
    abandoned: "Abandoned",
    cardStatus: "Card status",
    activationDate: "Activation date",
    expirationDate: "expiration date",
    operators: "Operators",
    cardUsage: "Current monthly card usage",
    syncTime: "Synchronization time",
    enterIccicd: "Please enter the ICCID number",
    enterSupplier: "Please enter the supplier",
    modifyRemarks: "Modify remarks",
    SIMCardScrapping: "SIM card scrapping",
    abandonedSuccessfully: "Abandoned successfully",
  },
  // 电池管理-电池档案
  BatteryFile: {
    batteryNumber: "Battery Number",
    carId: "Vehicle ID",
    terminalId: "Terminal ID",
    orgName: "Organization Name",
    batteryType: "Battery Type",
    power: "Rated Voltage (V)",
    capacity: "Rated Capacity (Ah)",
    ratedChargingSpeed: "Rated Charging Threshold (%/h)",
    ratedDischargeSpeed: "Rated Discharge Threshold (%/h)",
    plumbicAcid: "Lead-Acid",
    lithium: "Lithium",
    transferDialong: "Battery Transfer",
    batteryNumber: "Battery Number - Ownership",
    roleId: "Target Position",
    addDialong: "Bind Vehicle",
    form: {
      terminalId: "Enter terminal ID",
      typeId: "Select terminal type",
      batteryType: "Select battery type",
    },
    btn: {
    }
  },
  // 电池管理-电池状态
  BatteryStatus: {
    batteryNumber: "Battery Number",
    carId: "Vehicle ID",
    terminalId: "Terminal ID",
    orgName: "Organization Name",
    batteryType: "Battery Type",
    power: "Rated Voltage (V)",
    voltage: "Voltage",
    batteryInform: "Battery Information",
    batteryPower: "Voltage",
    batteryElectricity: "Battery Level",
    capacity: "Rated Capacity (Ah)",
    ratedChargingSpeed: "Rated Discharge Threshold (v/min)",
    ratedDischargeSpeed: "Rated Charging Threshold (%/h)",
    baseInform: "Basic Information",
    to: "To",
    starDate: "Start Date",
    endDate: "End Date",
    chargeAndDischarge: "Charge and Discharge",
    chargeAndDischargeRecord: "Charge and Discharge Record",
    batteryVoltageRecord: "Battery Voltage Record",
    charge: "Charge",
    discharge: "Discharge",
    isWarning: "Abnormal State",
    batteryWarning: "Abnormal State",
    normal: "Normal",
    abnormal: "Abnormal",
    happenTime: "Start Time",
    trouble: "Trouble",
    endTime: "End Time",
    happenElectricity: "Start Battery Level (%)",
    endElectricity: "End Battery Level (%)",
    continuedTime: "Duration (H)",
    judgeRate: "Threshold Value",
    rate: "Actual Value",
    chargeType: "Type",
    dateRange: "Date Range",
    noData: "No Data",
    leisure: "Idle",
    work: "Working",
    messageTime: "Report Time",
    batteryState: "State",
    plumbicAcid: "Lead-Acid",
    lithium: "Lithium",
    form: {
      batteryState: "Select Battery State",
      batteryWarning: "Select Abnormal State",
      batteryType: "Select Battery Type",
    },
    btn: {
    }
  },
  //效率分析-电池分析
  BatteryAnalysis: {
    batteryNumber: "Battery Number",
    carId: "Vehicle ID",
    terminalId: "Terminal ID",
    orgName: "Organization Name",
    chargeTimeH: "Charging Duration (H)",
    chargeTime: "Charging Duration",
    chargeCount: "Charging Count",
    dischargeTime: "Discharge Duration",
    dischargeCount: "Discharge Count",
    dischargeTimeH: "Discharging Duration (H)",
    warningCount: "Abnormal Count",
    warningCountH: "Abnormal Count (H)",
    happenTime: "Start Time",
    endTime: "End Time",
    happenElectricity: "Start Battery Level",
    endElectricity: "End Battery Level",
    eventInterval: "Duration",
    judgeRate: "Threshold Value",
    isWarningStr: "Abnormal State",
    eventInterval: "Actual Threshold Value",
    chargeTypeStr: "Type",
    count: "Count",
    duration: "Duration",
    date: "Date",
    to: "To",
    starDate: "Start Date",
    endDate: "End Date",
    chargeAndDischargeTimeH: "Charge and Discharge Duration (H)",
    carUseDetail: "Vehicle Usage Details",
    normal: "Normal",
    abnormal: "Abnormal",
    rate: "Use Rate",
    form: {
      batteryNumber: "Enter Battery Number",
      carId: "Enter Vehicle ID",
      batteryType: "Select Battery Type",
    },
    btn: {
    }
  },
  //效率分析-司机分析
  DriverAnalysis: {
    driverNum: "Driver Number",
    driverNo: "Driver Number",
    name: "Driver Name",
    carId: "Vehicle ID",
    terminalId: "Terminal ID",
    workTime: "Usage Duration within Statistics",
    todayWork: "Today's Working Hours",
    orgName: "Organization Name",
    workTimeH: "Accumulated Usage Duration",
    cardCount: "Card Swipes within Statistics",
    cardCountH: "Accumulated Card Swipes",
    alarmCount: "Violations within Statistics",
    alarmCountH: "Accumulated Violations",
    driverName: "Driver's Name",
    swipesRank: "Card Swipe Count Ranking",
    noData: "No Data",
    workTimeH: "Working Hours (H)",
    violationRank: "Violation Count Ranking",
    happenElectricity: "Starting Battery Level",
    endElectricity: "Ending Battery Level",
    eventInterval: "Duration",
    judgeRate: "Threshold Value",
    isWarningStr: "Abnormal State",
    eventInterval: "Actual Threshold Value",
    chargeTypeStr: "Type",
    count: "Count",
    duration: "Duration",
    date: "Date",
    to: "To",
    driverWorkRecord: "driver work record",
    starDate: "Start Date",
    endDate: "End Date",
    timOfTheDay: "Time of the Day",
    nearlyMonth: "Within a Month",
    cumulativeTime: "Cumulative Time",
    choseTime: "Choose Time",
    workHour: "Working Hours",
    useTimeRate: "Work Efficiency",
    startTime: "Start Time",
    endTime: "End Time",
    useRate: "Usage Rate",
    userTime: "Usage Duration",
    dailyCarHour: "Daily Vehicle Hours",
    dailyWorkHour: "Daily Working Hours",
    dayUseRate: "Daily Usage Rate",
    dayUseTime: "Daily Usage Duration",
    twentyFourHourSystem: "24-Hour System",
    eightHourSystem: "8-Hour System",
    driverWorkCollect: "Driver Work Summary",
    moveTime: "Moving Time",
    carryWeightTime: "Carry Time",
    freeTime: "Idle Time",
    moveLoadRate: "Moving Load Efficiency",
    carryDuration: "Carry Duration",
    freeDuration: "Idle Duration",
    rate: "Usage Rate",
    dailyCarRate: "Daily Vehicle Efficiency",
    driverWorkDetail: "Driver Work Details",
    totalWorkHour: "Total Work Hours",
    overloadCount: "Overload Count",
    speedOverCount: "Speeding Count",
    outPositionCount: "Out of Position Count",
    collisionCount: "Collision Count",
    leaveFenceCount: "Out of Fence Count",
    violationTime: "Violation Time",
    eventMessage: "Violation Type",
    value: "Quantity (Times)",
    todayVolation: "Today's Violations",
    violationTrend: "Violation Trend",
    violationProp: "Violation Ratio",
    violationDetail: "Violation Details",
    form: {
      driverNum: "Enter Driver's License Number",
      name: "Enter Driver's Name",
      driverName: "Enter Driver's Name",
    },
    btn: {
    }
  },
  //效率分析-维保分析
  MaintenanceAnalysis: {
    batteryNumber: "Battery Number",
    carId: "Vehicle ID",
    terminalId: "Terminal ID",
    orgName: "Organization Name",
    maintainPeopleCost: "Maintenance Labor Cost",
    maintainMaterialCost: "Maintenance Material Cost",
    maintainCount: "Maintain Number",
    repairCount: "Repairs Number",
    repairPeopleCost: "Repair Labor Cost",
    repairMaterialCost: "Repair Material Cost",
    repairCostRate: "Repair Cost Ratio",
    maintainCostRate: "Maintenance Cost Ratio",
    yuan: "Yuan",
    moneyYuan: "Amount (Yuan)",
    lastYearMaintainCost: "Total Maintenance Cost Last Year",
    thisYearMaintainCost: "Total Maintenance Cost This Year",
    yearOnYearGrowthRate: "Year-on-Year Growth Rate",
    monthOnMonthGrowthRate: "Month-on-Month Growth Rate",
    riseRate: "Growth Rate",
    repairCostCompar: "Comparison of Repair Costs",
    form: {
      carId: "Enter Vehicle ID",
    },
    btn: {
    }
  },
  //效率分析-车辆分析
  VehicleAnalysis: {
    manufactureNum: "Manufacture Number",
    carId: "Vehicle ID",
    plateNum: "License Plate Number",
    customNum: "Custom Number",
    orgName: "Organization Name",
    terminalId: "Terminal ID",
    startStopTime: "Start stop times",
    stopCountH: "Accumulated Number of Stops",
    workTime: "Usage Duration within Statistics",
    workTimeH: "Accumulated Usage Duration",
    problemCount: "Number of Problems within Statistics",
    faultFrequency: "Fault frequency",
    problemCountH: "Accumulated Number of Problems",
    rank: "Stop Count Ranking",
    useTimeH: "Usage Duration (Hours)",
    problemRank: "Problem Count Ranking",
    num: "Number",
    workHour: "WorkingHours",
    dayilyWorkHour: "Daily Working Hours",
    carWorkRecord: "Vehicle Work Records",
    carWorkDriverNum: "Driver Number",
    carWorkGroupName: "Group Name",
    carWorkDriverName: "Driver Name",
    carWorkStartTime: "Start Time",
    carWorkEndTime: "End Time",
    carWorkDuration: "Work Duration",
    hour: "Hours",
    useTimeRate: "Work Efficiency",
    driverNum: "Driver Number",
    driverName: "Driver's Name",
    startTime: "Start Time",
    endTime: "End Time",
    useRate: "Usage Rate",
    carDayEfficiency: "Daily Vehicle Efficiency",
    todayWorkTime: "Today's Working Hours",
    carUseDetail: "Vehicle Usage Details",
    moveTime: "Moving Time",
    carryWeightTime: "Carry Weight Time",
    freeTime: "Free Time",
    carryWeightRate: "Moving Load Efficiency",
    moveMileage: "Mileage",
    stopCount: "Number of Air Filter Clogs",
    airStop: "Air Filter Clog",
    lowLiquidLevelCount: "Low Liquid Level",
    lowOilCount: "Low Oil Pressure",
    lowPowerCount: "Low Voltage",
    problemTime: "Problem Time",
    eventMessage: "Problem Type",
    value: "Quantity (Times)",
    problemCount: "Today's Problems",
    problemTrend: "Problem Trend",
    problemDetail: "Problem Details",
    problemProp: "Problem Ratio",
    totalWorkTime: "Total Work Time",
    form: {
      carId: "Enter Vehicle ID",
    },
    btn: {
    }
  },
  //司机管理
  DriverManagement: {
    manufactureNum: "Manufacture Number",
    carId: "Vehicle ID",
    plateNum: "License Plate Number",
    customNum: "Custom Number",
    orgName: "Organization Name",
    terminalId: "Terminal ID",
    terminalType: "Terminal Model",
    messageTime: "Report Time",
    linkState: "Device Status",
    onLine: "Online",
    offLine: "Offline",
    authorizeCount: "Number of Registered Fingerprints",
    authorizes: "Authorized Quantity",
    fingers: "Fingerprint Quantity",
    driverNum: "Driver's License Number",
    name: "Driver's Name",
    fingerGroup: "Fingerprint Number",
    fingerGroupId: "Fingerprint Library Number",
    fingerGroupName: "Fingerprint Library Name",
    number: "Authorization Number",
    authorizeType: "Authorization Type",
    createTime: "Operation Date",
    num: "Number",
    to: "To",
    deny: "NO",
    correct: "YES",
    fingerAuthorize: "Fingerprint Authorization",
    keyAuthorize: "Key Card Authorization",
    faceAuthorize: "Face Authorization",
    authorizePower: "Authorization Power",
    normalAuthorize: "Normal Authorization",
    adminAuthorize: "Admin Authorization",
    authorizeDriver: "Authorized Driver",
    nearTime: "Near Expiry",
    normal: "Normal",
    exceed: "Expired",
    driverExpires: "Driver's Annual Review Expiry Date",
    driverExpiresType: "Annual Review Status",
    remarks: "Remarks",
    jurisdictionName: "Jurisdiction Name",
    nowExpireDate: "Current Expiry Date",
    changeExpireDate: "Change Expiry Date",
    auditState: "Audit Result",
    auditOpinion: "Audit Opinion",
    driverAnnualSuccess: "Driver Annual Review Successful",
    driverAnnual: "Driver Annual Review",
    approvalProgress: "Approval Progress",
    filePath: "Image",
    annualAgain: "Annual Review Again",
    isAuth: "Is Authorized",
    terminalType: "Terminal Type",
    addTermianlSetting: "Add Terminal Configuration",
    choseTerminal: "Choose Terminal",
    loginName: "Associated Platform Account",
    linkAccount: "Link Account",
    phone: "Phone Number",
    card: "ID Card Number",
    email: "Email",
    rolePower: "Role Permissions",
    roleData: "Data Permissions",
    transfer: "Driver Transfer",
    driverNumBelong: "Driver's License Number - Belonging",
    roleId: "Destination",
    oldDriverNum: "Old Driver's License Number",
    newDriverNum: "New Driver's License Number",
    fingerNum: "Number of Registered Fingerprints",
    work: "Work",
    leisure: "Leisure",
    state: "Work State",
    startTime: "Start Time",
    endTime: "End Time",
    workHour: "Working Hours",
    trainTitle: "Training Title",
    examEndTime: "Exam Deadline",
    examDuration: "Exam Duration(minute)",
    examQuestion: "Exam Questions",
    examDriver: "Exam Driver",
    examDriverCount: "Exam Driver Count",
    examPassMark: "Passing Mark (out of 100)",
    examResult: "Exam Result (Passed/Total)",
    result: "Exam Result",
    noExam: "Not Taken",
    exam: "Taken",
    noPass: "Failed",
    pass: "Passed",
    misssExam: "Missed",
    questionAnswerStr: "Answers",
    examStateStr: "Exam Status",
    driverExamTime: "Exam Time",
    examResult: "Exam Result",
    numOrName: "Driver's License Number/Driver's Name",
    fingerBankName: "Fingerprint Library Name",
    adminNum: "Number of Admins",
    normalNum: "Number of Normal Users",
    adminList: "Admin List",
    normalList: "Normal User List",
    normalFinger: "Normal Fingerprint",
    adminFinger: "Admin Fingerprint",
    fingerBankBelong: "Fingerprint Library Number - Belonging",
    keyNum: "Key Card Number",
    makeKeyTime: "Key Card Production Time",
    normalPeople: "Normal Users",
    adminPeople: "Admin Users",
    makeKey: "Make Key Card",
    faceUpdateTime: "Face Image Update Time",
    faceData: "Face Data",

    teamName: "Team name",
    teamNumber: "Team number",
    addTeam: "Newly added team",
    editTeam: "Modify Team",
    administrativeStaff: "administrative staff",
    ordinaryPersonnel: "Ordinary personnel",
    operatType: "Operation Type",
    operator: "operator",
    operatTime: "Operating Time",
    authorizationTime: "Authorization Time",

    form: {
      carId: "Enter Vehicle ID",
      driverName: "Enter Driver's Name",
      terminalType: "Select Terminal Type",
      groupId: "Select Terminal Upload Type",
      keyId: "Select Command Name",
      terminalId: "Enter Terminal ID",
      confirmClear: "Are you sure you want to clear?",
      clearSuccess: "Cleared successfully",
      confirmSync: "Are you sure you want to sync?",
      syncSuccess: "Synced successfully",
      linkState: "Select Device Status",
      authorizeType: "Select Authorization Type",
      authorizePower: "Select Authorization Power",
      driverNum: "Select Authorized Driver",
      driverNumber: "Enter Driver's License Number",
      confirmSyncFinger: "Are you sure you want to sync fingerprints?",
      // syncSuccess: "Synced successfully",
      changeDriverNum: "Change Driver's License Number",
      deliveryTime: "Select Delivery Time",
      addDriverFingerSuccess: "Added driver fingerprint successfully",
      state: "Select Device Status",
      trainTitle: "Enter Training Title",
      examEndTime: "Select Exam Deadline",
      examDuration: "Enter Exam Duration",
      examPassMark: "Enter Passing Mark",
      downloadExamPeopleModle: "Download Exam Candidate Template",
      downloadExamQuestionModle: "Download Exam Question Template",
      choseFingerNum: "Select Fingerprint Library Code",
      choseDriverNum: "Select Authorized Driver",
      choseFingerBankName: "Select Fingerprint Library Name",
      choseDriver: "Selected Driver",
      allDriver: "All Drivers",
      chooseDriver: "Choose Driver",
      fingerBankBelong: "Fingerprint Library Number - Belonging",
      transferFingerBank: "Transfer Fingerprint Library",
      batchAuth: "Batch Authorization",
      inputAuthType: "Enter Authorization Type",
      choseAuthType: "Select Authorization Type",
      sendContent: "Send content",
      uploadExamQuestion: "Please upload exam questions",
      uploadExamDriver: "Please upload the examiners",
    },
    btn: {
      cancelSend: "Clear",
      syncDriver: "Driver Sync",
      synchro: "Fingerprint Sync",
      addAuthorize: "Add Authorization",
      add: "Add Driver",
      addKey: "Add Key Card",
      edit: "Edit Driver",
      addDriverFinger: "Add Driver Fingerprint",
      addFinger: "Add Fingerprint",
      authFingeBank: "Fingerprint Library Authorization",
      editFinger: "Edit Fingerprint",
      addFingerSuccess: "Added Fingerprint Successfully",
      editFingerSuccess: "Edited Fingerprint Successfully",
      transferFingerBank: "Transfer Fingerprint Library",
      updateDriverFace: "Update Face Data",
      authorizedPerson: "authorized personnel",
      operationLog: "Operation log",
    }
  },
  //政府监管
  GovernmentRegulation: {
    nowExpireDate: "Current Expiry Date",
    changeExpireDate: "Change Expiry Date",
    approve: "Approval",
    auditOpinion: "Approval Opinion",
    feedbackContent: "Feedback Content",
    feedbackTime: "Feedback Time",
    noteTitle: "Title",
    describe: "Description",
    carFilePath: "Vehicle Information Image",
    sceneFilePath: "Scene Image",
    companyReplyMessage: "Company Reply Message",
    waitReply: "Awaiting Reply",
    haveReplied: "Replied",
    haveClosed: "Closed",
    noteState: "Note State",
    carCount: "Vehicle Count",
    driverCount: "Driver Count",
    driverCarRate: "Vehicle-Driver Ratio",
    linkCarCount: "Number of Online Vehicles within 10",
    onLinkCarCount: "Number of Offline Vehicles within 10",
    InsufficientManMachineRatio: "Insufficient Man-Machine Ratio",
    SuspectedEquipmentRemoval: "Suspected Equipment Removal",
    emissionRatio: "Emission Ratio",
    safe: "Safe",
    noSafe: "Unsafe",
    safeEquiteRatio: "Safe Equipment Ratio",
    maintenanceRatio: "Maintenance Ratio",
    car: "Vehicle",
    normal: "Normal",
    nearTime: "Near Term",
    exceedTime: "Exceed Term",
    checked: "Checked",
    noCheck: "Unchecked",
    checkRatio: "Check Ratio",
    abnormal: "Abnormal",
    checkAbnormalRatio: "Check Abnormality Ratio",
    overview: "Overview",
    carAgeRatio: "Vehicle Age Ratio",
    driverNum: "Driver ID",
    name: "Driver Name",
    overloadCount: "Overload Count",
    speedOverCount: "Speeding Count",
    safeBelt: "Safety Belt",
    collisionCount: "Collision Count",
    leaveFenceCount: "Out of Fence Count",
    endTime: "Violation Time",
    eventMessage: "Violation Type",
    value: "Count",
    violationTrend: "Violation Trend",
    noData: "No Data",
    violationRatio: "Violation Ratio",
    violationDetail: "Violation Detail",
    overloadCountVlaue: "Overload Count",
    speedOverCountVlaue: "Speeding Count",
    safeBeltVlaue: "Safety Belt Count",
    collisionCountVlaue: "Collision Count",
    leaveFenceCountVlaue: "Out of Fence Count",
    eventInterval: "Violation Duration",
    companyViolationAnalysis: "Company Violation Analysis",
    carViolationDetail: "Vehicle Violation Detail",
    carExpiresType: "Vehicle Inspection Status",
    insureType: "Insurance Status",
    safeList: "Safety Accessories",
    brandName: "Brand",
    brandTypeName: "Model",
    type: "Power Type",
    carEmissionName: "Emission Standard",
    carSaveAddress: "Vehicle Storage Address",
    companyNum: "Unified Social Credit Code",
    email: "Company Email",
    companyAddress: "Company Address",
    driverExpires: "Driver's License Expiry Date",
    driverExpiresType: "Driver's License Status",
    regulationsContent: "Content",
    issueTime: "Release Date",
    isFilePath: "Attachment Download",
    filePath: "File Path",
    driverAnnualReview: "Driver Annual Review",
    carAnnualReview: "Vehicle Annual Review",
    form: {
      approveResult: "Approval Result for this Vehicle",
      pass: "Pass",
      noPass: "Reject",
      driverApproveResult: "Approval Result for this Driver",
      lawNotes: "Law Notes",
      companyName: "Enter Company Name",
      companyNum: "Enter Unified Social Credit Code",
    },
    btn: {
      batchApprove: "Batch Approval",
    }
  },
  //首页
  HomPage: {
    comStatistics: "Comprehensive Statistics",
    carNum: "Total Vehicles",
    onTower: "Online Count",
    failTower: "Faulty Count",
    todayWork: "Due Today",
    violaTower: "Violation Count",
    violationToday: "Today's Violations",
    unit: "Units",

    annualAudit: "Annual Audit",
    compliance: "Compliance",
    insurance: "Insurance",
    exceedTime: "Overdue",
    innerRing: "Inner Ring",
    year: "Year",
    carAgeRatio: "Vehicle Age Ratio",
    carryingCapacityStatistics: "Load Capacity Statistics",
    conform: "Conform",
    inconform: "Inconform",
    total: "Total",
    forklift: "Forklifts",
    vehicleWorkingRate: "Vehicle Working Rate",
    checkPassRate: "Check Pass Rate",
    high: "High",
    low: "Low",
    shenYang: "Shenyang",
    weather: "Weather",
    dynamicStatistics: "Power Statistics",
    carCount: "Total Vehicles",
    dieselVehicle: "Diesel Vehicles",
    electrocar: "Electric Vehicles",
    cars: "Vehicles",
    AnnualAuditStatistics: "Annual Audit Statistics",
    noData: "No Data",
    QingdaoMarketLogisticsEquipmentInformationPlatform: "Qingdao Market Logistics Equipment Information Platform",
    day: "Days",
    SafeOperatingDaysOfTheDevice: "Safe Operating Days of the Device",
    hour: "Hours",
    CumulativeRunningTime: "Cumulative Running Time",
    toggleFullScreen: "Toggle Full Screen",
    backManagement: "Back Management",
    proportionOfNewRegulations: "Proportion of Compliance with New Regulations",
    newRegulationsCount: "Total Vehicles Compliant with New Regulations",
    insuranceCoverage: "Insurance Coverage",
    sevenDayVehicleWorkingRate: "Seven-Day Vehicle Working Rate",
    sevenDayCheckPassRate: "Seven-Day Check Pass Rate",
    qingPuArea: "Qingpu Area",
    QingdaoMarketLogisticsEquipmentInformationPlatform: "Qingpu Area Market Logistics Equipment Information Platform",
    workTime: "Working Time",
    onlineCount: "Online Count",
    offLineCount: "Offline Count",
    carTotal: "Total Vehicles",
    overload: "Overload",
    speedOver: "Speeding",
    positionTimeout: "Position Timeout",
    collision: "Collision",
    leaveFence: "Leaving Fence",
    value: "Count",
    ForkliftIntelligentManagementPlatform: "Forklift Intelligent Management Platform",
    exitFullScreen: "Exit Full Screen",
    fullScreen: "Full Screen",
    chargeCar: "Charging Vehicles",
    maintainAdventCar: "Maintain Due Vehicles",
    workCar: "Working Vehicles",
    maintainExceedCar: "Overdue Maintenance Vehicles",
    leisureCar: "Idle Vehicles",
    licensesAdventValue: "Driver's License Due",
    todayFault: "Today's Faults",
    FilterPluggingCount: "Air Filter Blocking",
    LowOilPressureCount: "Low Oil Pressure",
    LowPowerCount: "Low Power",
    LowLiquidLevelCount: "Low Liquid Level",
    todayCarWorkTimeRank: "Today's Vehicle Working Time Ranking (TOP10)",
    todayDriverWorkTimeRank: "Today's Driver Working Time Ranking (TOP10)",

    MasterKong: {
      ManagementPlatform: "Master Kong Forklift Intelligent Management Platform",
      VehicleConditionDay: "Vehicle condition on the day",
      VehicleConditionBranchOffice: "Vehicle Condition of the Branch Office",
      WeeklyWorkHoursRank: "Weekly working hours ranking",
      VehicleOperationDuration: "Vehicle operation duration",
      DriverSituationAnalysis: "Driver situation analysis",
      StatisticsDriversBranchOffices: "Statistics of drivers in branch offices",
      DriverHourRank: "Driver hour ranking",
      rank: "ranking",
      averageWorkHours: "Average working hours",
      vehiclesDayHour: "Hour/vehicles/day",
      branchCompany: "branch company",
    },
    form: {
      yourBrowserDoesNotSupportFullScreen: "Your browser does not support full screen mode",
    },
    btn: {
    }
  },
  //平台设置
  PlatformSettings: {
    checkName: "Check Name",
    benchmark: "Inspection benchmark",
    checkType: "Inspection type",
    operate: "Operate",
    brandManagement: "Brand Management",
    brandName: "Brand Name",
    type: "Type",
    orgDetail: "Organization Detail",
    superId: "Superior ID",
    lowerNum: "Lower Quantity",
    level: "Level",
    userName: "Username",
    loginName: "Account",
    name: "name",
    email: "Email",
    subscribe: "Subscribe",
    operate: "Operate",
    reportSend: "Report Sending",
    dailyReport: "Daily",
    weekReport: "Weekly",
    monthReport: "Monthly",
    dailyMonthReport: "Daily & Monthly",
    roleName: "Role Name",
    roleUserNum: "User Count",
    listSet: "Column Configuration",
    menu: "Platform Page Permissions",
    appMenu: "APP Page Permissions",
    menuDetail: "Menu Details",
    role: "Role",
    phone: "Phone",
    expiryDate: "Expiry Date",
    dailyMonthReport: "Valid Date",
    loginCount: "Login Count",
    rolePower: "Role Permissions",
    roleData: "Data Permissions",
    system: "system",
    englishName: "English name",
    chineseName: "Chinese name",
    typesOf: "types of",
    icon: "icon",
    routingAddress: "Routing address",
    form: {
      sendSuccess: "Sent Successfully",
      cancelSuccess: "Cancelled Successfully",
      editSortFail: "Failed to Edit Sort",
      addCheckSuccess: "Check Added Successfully",
      editCheckSuccess: "Check Edited Successfully",
      addBrand: "Add Brand",
      editBrand: "Edit Brand",
      addBrandSuccess: "Brand Added Successfully",
      editBrandSuccess: "Brand Edited Successfully",
      addTypeSuccess: "Type Added Successfully",
      editTypeSuccess: "Type Edited Successfully",
      roleName: "Enter Role Name",
      addRoleSuccess: "Role Added Successfully",
      editRoleSuccess: "Role Edited Successfully",
      editUserSuccess: "User Edited Successfully",
      inputCheckName: "Enter Check Name"
    },
    btn: {
      loginName: "Enter Account",
      userName: "Enter Username",
      rolePower: "Select Role Permissions",
      expiryDate: "Select Expiry Date",
      pleaseSelectSystem: "Please select a system",
      pleaseEnterEnglishName: "Please enter an English name",
      pleaseEnterChineseName: "Please enter a Chinese name",
      pleaseSelectType: "Please select type",
      pleaseSelectSorting: "Please select sorting",
      pleaseEnterAddress: "Please enter the routing address",
    }
  },
  //安全管理
  SafeManagement: {
    TabRemind: "Inspection Reminder",
    TabAnalysis: "Inspection Analysis",
    TabReportForm: "Inspection Report",
    Checked: "Checked",
    Unchecked: "Unchecked",
    stop: "Machine Stoppage Inspection",
    stoped: "Stopped",
    spotCheckDate: "Last Inspection Date",
    spotCheckType: "Inspection Status",
    carUseState: "Vehicle Use Status",
    happenTime: "Inspection Date",
    InspectionResults: "Inspection Results",
    InspectionPersonnel: "Inspector",
    abnormalState: "Abnormal Status",
    checkRatio: "Inspection Rate",
    checkAbnormalRatio: "Abnormal Inspection Rate",
    queryCheckRecord: "Inspection Record Query",
    checkName: "Inspection Name",
    carMileage: "Mileage",
    check: "Inspection",
    resubmissions: "Resubmit",
    totalWorkTime: "Total Working Hours",
    fenceName: "Fence Name",
    centerLng: "Longitude",
    centerLat: "Latitude",
    radius: "Radius",
    level: "Level",
    fencingPoints: "Fencing points",
    serialNumber: "Command Serial Number",
    terminalTypeName: "Terminal Type",
    terminalType: "Terminal Command Type",
    aliKey: "Command Category",
    keyName: "Command Name",
    sendContent: "Command Content",
    receivedTime: "Delivery Time",
    state: "Status",
    sending: "Sending",
    exceedFail: "Expired Failure",
    success: "Success",
    uploadTerminalType: "Terminal Upload Type",
    serverSet: "Server Settings",
    voiceSet: "Voice Dispatch",
    setNum: "Dispatch Frequency",
    wifiName: "WIFI Name",
    wifiPassWord: "WIFI Password",
    initializePassWord: "Initialization Password",
    idNum: "ID Number",
    retry: "Retry",
    eventMessage: "Alarm Event Type",
    eventValue: "Value",
    startTime: "Event Start Time",
    endTime: "Event End Time",
    alarmType: "Alarm Type",
    illegalType: "Violation Type",
    form: {
      carUseState: "Please select the vehicle use status",
      checkSuccess: "Inspection successful",
      queryReport: "View report",
      ThereAreAbnormalItemsInTheProjectYouSubmittedWhetherToSubmit: "There are abnormal items in the project you submitted. Please fill in the reason for the abnormality in the remarks before submitting",
      addFence: "Create fence",
      editFence: "Edit fence",
      addFenceSuccess: "Fence added successfully",
      editFenceSuccess: "Fence edited successfully",
      selectServerSet: "Please select server settings",
      retrySuccess: "Retry successful",
      uploadTerminalType: "Select terminal upload type",
      selectTerminal: "Select terminal",
      importTerminal: "Import terminal",
      uploadTerminalFile: "Upload terminal file",
      chooseKeyName: "Please choose command name",
      chooseServer: "Please choose server",
      importVoiceSet: "Please enter voice dispatch",
      importSetNum: "Please enter dispatch frequency",
      importWifiName: "Please enter WIFI name",
      importWifiPassWord: "Please enter WIFI password",
      importInitializePassWord: "Please enter initialization password",
      alarmType: "Please select alarm type",
      illegalType: "Please select violation type",
      pleaseEnterKilometers: "Please enter the kilometers",
    },
    btn: {
      spotCheck: "Inspection",
      addSimpleSet: "Add Simple Configuration",
      addComPlexSet: "Add Complex Configuration",
      downloadModle: "Download Template",
      addTerminalSet: "Add Terminal Configuration",
      retrySetOrder: "Retry Configuration Command",
      determineGenerateRepairOrder: "Determine and generate a repair order",
    }
  },
  //车辆管理
  VehicleManagement: {
    basicInformation: "Basic Information",
    generate: "Generate",
    engineNo: "Engine Number",
    storageAddress: "Storage Address",
    frameNumber: "Frame number",
    forkliftType: "Forklift type",
    serviceLife: "service life",
    vehicleModelInformation: "Vehicle Model Information",
    vehicleEmissions: "Vehicle Emissions",
    combustionEngine: "Combustion Engine",
    motor: "Motor",
    sizeInformation: "Size Information",
    length: "Length",
    width: "Width",
    height: "Height",
    forkLength: "Fork Length",
    portalNum: "Portal Number",
    maxLift: "Max Lift",
    clampRange: "Clamp Range",
    maintenanceInformation: "Maintenance Information",
    isMaintain: "Maintenance Status",
    deny: "No",
    correct: "Yes",
    reminderCycle: "Reminder Cycle",
    serviceInterval: "Service Interval",
    accessoriesInformation: "Accessories Information",
    selectAll: "Select All",
    belongTo: "Belong To",
    targetPosition: "Target Position",
    originalTerminalNumber: "Original Terminal Number",
    newTerminalNumber: "New Terminal Number",
    originalVehicleNumber: "Original Vehicle Number",
    newVehicleNumber: "New Vehicle Number",
    currentExpirationDate: "Current Expiration Date",
    annualReviewName: "Annual Review Organization Name",
    annualReviewCode: "Annual Review Registration Code",
    changeExpireDate: "Change Expiration Date",
    picture: "Picture",
    reAnnualReview: "Re-Annual Review",
    InspectionInformation: "Inspection information",
    IsThereSpotCheck: "Is there a spot check",

    voltage: "Voltage",
    speed: "Speed",
    carryWeight: "CarryWeight",
    address: "Address",
    state: "State",
    province: "Province",
    city: "City",
    maintenancePerson: "Maintenance Personnel",
    syncState: "Sync State",
    powerType: "Power Type",
    terminalBindDate: "Terminal Binding Date",
    brandModel: "Brand Model",
    insureStartTime: "Insurance Start Date",
    insureEndTime: "Insurance End Date",
    isInsureFilePath: "Insurance Attachment",
    isInsureState: "Insurance Status",
    materialName: "Material Name",
    num: "Quantity",
    amount: "Amount",
    repairMaterialCost: "Repair Material Cost",
    repairCostRate: "Repair Cost Rate",
    maintainCostRate: "Maintenance Cost Rate",
    yuan: "Yuan",
    moneyYuan: "Amount (Yuan)",
    serialNumber: "Serial Number",
    carWorkTime: "Vehicle Total Working Time",
    repairPerson: "Repair Person",
    repairTime: "Repair Time",
    phone: "Phone",
    situationDescription: "Situation Description",
    urgeCount: "Reminder Count",
    repairStateStr: "Repair Status",
    state: "State",
    unFinish: "Unfinished",
    finish: "Finished",
    maintain: "Maintain",
    remind: "Remind",
    repairBill: "Repair Bill",
    maintainBill: "Maintenance Bill",
    operateUser: "Operator",
    operateTime: "Operation Time",
    repairType: "Fault Type",
    peopleCost: "Labor Cost",
    repariContent: "Repair Content",
    serialContent: "Maintenance Content",
    totalMoneny: "Total Cost (Yuan):",
    other: "Other",
    airStop: "Air Filter Blockage",
    lowLiquidLevelCount: "Low Liquid Level",
    lowOilCount: "Low Oil Pressure",
    lowPowerCount: "Low Voltage",
    serialPerson: "Maintenance Personnel",
    serialTime: "Maintenance Time",
    materialCost: "Total Material Cost",
    workTime: "Cumulative Work Time",
    nextMaintainTime: "Next Maintenance Time",
    maintainCycle: "Maintenance Cycle",
    maintainReminder: "Maintenance Reminder",
    lastMaintainTime: "Last Maintenance Time",
    serial: "Maintenance",
    serialBill: "Maintenance Bill",
    unapproved: "Unapproved",
    passed: "Passed",
    rejected: "Rejected",
    on: "On",
    off: "Off",
    noSync: "Not Synced",
    fail: "Fail",
    success: "Success",
    phone: "Phone Number",
    baseInform: "Basic Information",
    card: "ID Card Number",
    driverExpires: "Driver's License Expiration Date",
    workHour: "Working Hours",
    openTime: "Start Time",
    closeTime: "End Time",
    firmwareVersion: "Firmware Version",
    terminalType: "Terminal Type",
    simIccicd: "ICCID Number",
    simNumber: "SIM Card Number",
    deliveryTime: "Delivery Time",
    baseData: "Basic Data",
    motorNum: "Engine Number",
    carTypeData: "Vehicle Model Data",
    brandId: "Brand",
    brandTypeId: "Model",
    carType: "Vehicle Model",
    capacity: "Capacity",
    carInfom: "Vehicle Information",
    termianlInform: "Terminal Information",
    driverInform: "Driver Information",
    carWorkStatus: "Vehicle Working Status",
    runningData: "Running data",
    offlineDuration: "Offline Duration",
    deviceStatus: "Device Status",
    workCondition: "Working Condition",
    faultConditions: "Fault Condition",
    oneTwo: "0-1 Days",
    oneThree: "1-3 Days",
    threeSeven: "3-7 Days",
    sevenTen: "7-10 Days",
    ten: "10+ Days",
    fault: "Fault",
    faultItems: "Fault Items",
    maintenanceTime: "Maintenance Time",
    carList: "car List",
    selectedCar: "selected car",
    entryName: "entry name",
    projectDescription: "Project Description",
    newProject: "New Project",
    modifyProject: "Modify project",
    maintenanceSuggestions: "Maintenance suggestions",
    partName: "Part name",
    newProjectSuccessfully: "New project successfully created",
    projectModificationSuccessful: "Project modification successful",
    maintenanceItems: "Maintenance items",
    selectMaintenanceDate: "Select maintenance date",
    mainMaintenanceItems: "Main maintenance items",
    replaceParts: "Replace parts",
    numberOfMaintenanceItems: "Number of maintenance items",
    todayCheck: "Today's inspection",
    mainTerminalId: "Main terminal number",
    subTerminalId: "Sub terminal number",
    newMainTerminalId: "New main terminal number",
    SubTerminalId: "New secondary terminal number",
    MaintenanceMaterials: "Maintenance materials",
    unaccepted: "Unaccepted",
    repaired: "To be repaired",
    alreadyRepaired: "Already repaired",
    closed: "Closed",
    PendingRepairRequest: "Pending Repair Request",
    PendingProcessingViolations: "Pending Processing Violations",
    PendingFault: "Pending Fault",
    stopStatusReported: "Stop status reported",
    stopTimeReporting: "Stop time reporting",
    pushStatus: "Push status",
    baseWorkHours: "Base working hours",
    inspectionInterval: "Inspection interval",
    form: {
      imputCarid: "Please enter the vehicle number",
      repairPerson: "Please enter the repair person",
      repairTime: "Please select the repair time",
      phone: "Please enter the contact phone number",
      serialNumber: "Please enter the repair order serial number",
      maintainPerson: "Please enter the maintenance personnel",
      maintainTime: "Please select the maintenance time",
      chooseFaultItem: "Please choose the fault item",
      confirmRemind: "Are you sure to remind?",
      remindSuccess: "Reminder success",
      confirmFinish: "Are you sure to finish?",
      finishSuccess: "Confirmed completion",
      repairType: "Please select the fault type",
      haveBeenRepaired: "Repaired",
      noClick: "Not repaired cannot be clicked!",
      imputMaintainPerson: "Please enter the maintenance person",
      chooseMaintainTime: "Please select the maintenance time",
      chooseMaintainType: "Please select the maintenance type",
      carAnnualAuditSuccess: "Vehicle annual audit success",
      manufactureNum: "Please enter the manufacturing number",
      brandId: "Please select the brand",
      brandTypeId: "Please select the model",
      type: "Please select the power type",
      capacity: "Please enter the capacity",
      deliveryTime: "Please select the delivery date",
      carEmissionId: "Please select the annual inspection expiration date",
      thereIsNoMotionTrajectoryInTheCurrentTimePeriod: "There is no motion trajectory in the current time period",
      enterBaseWorkHours: "Please enter the base working hours",
    },
    btn: {
      addNewLine: "New",
      startPlayBack: "Start",
      continuePlayBack: "Continue",
      stopPlayBack: "Pause",
      modifyVehicleNumber: "Modify Vehicle Number",
      bindTerminal: "Bind Terminal",
      replaceTerminal: "Replace Terminal",
      vehicleAllocation: "Vehicle Allocation",
      approvalProgress: "Approval Progress",
      vehiclePosition: "Vehicle Position",
      inspectionEnable: "Inspection Enable",
      vehiclePush: "Vehicle push",
    }
  }
};
